import { Collapse } from "react-bootstrap";
import Header from "components/Frame/Header";
import Sidebar from "components/Frame/Sidebar";
import useSidebar from "components/Frame/useSidebar";
import Content from "components/Frame/Content";

const Frame = ({ title, side, children }) => {
  const sidebar = side ? useSidebar("sidebar") : {};
  const { sidebarId, sidebarOpen, toggleSidebar } = sidebar;
  return <>
    <Header handleMenu={toggleSidebar} menuId={sidebarId} menuOpened={sidebarOpen}>{title}</Header>
    <div className="d-flex flex-nowrap">
      {Boolean(side) && (
        <Collapse in={sidebarOpen} dimension="width">
          <div id={sidebarId} >
            <Sidebar headerSpacing>{side}</Sidebar>
          </div>
        </Collapse>
      )}
      <Content headerSpacing>{children}</Content>
    </div>
  </>;
};

export default Frame;